import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReauth} from "./baseQuery";

export const createQuoteAPI = createApi({
  reducerPath: "createQuoteAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getRFQUserById: builder.query({
      query: (id) => {
        return {
          url: `api/orders/rfq/${id}/get_rfq_user/`,
        };
      },
    }),
    getAllVendors: builder.query({
      query: (params) => {
        return {
          url: "accounts/mob_vendor/",
          params,
        };
      },
    }),
    getCatalogueByVendor: builder.query({
      query: ({id, searchValue,page}) => {
        return {
          url: `api/product/vendor-product-search/?bmp_id=${id}&search=${
            searchValue || ""
          }&page=${page}`,
        };
      },
    }),
    getCatalogueByVendorDrawer: builder.query({
      query: ({params, id,page}) => {
        return {
          url: `api/product/vendor-product-search/?bmp_id=${id}&page=${page}`,
          params,
        };
      },
    }),
    getCatalogueByVendorModal: builder.query({
      query: ({id, slug}) => {
        return {
          url: `api/product/vendor-product-search/${slug}/get_product_details/?bmp_id=${id}`,
        };
      },
    }),
    createRFQQuote: builder.mutation({
      query: (newVendorData) => ({
        url: "api/orders/rfq/create_quote/",
        method: "POST",
        body: newVendorData,
      }),
    }),
    updateRFQQuoteDetails: builder.mutation({
      query: (newVendorData) => ({
        url: "api/orders/rfq/update_quote_details/",
        method: "PATCH",
        body: newVendorData,
      }),
    }),
    getRFQQuoteDetail: builder.query({
      query: (id) => ({
        url: `api/orders/rfq/${id}/get_quote/`,
      }),
    }),
    updateRFQQuote: builder.mutation({
      query: (updatedData) => ({
        url: "api/orders/rfq/update_quote/",
        method: "PATCH",
        body: updatedData,
      }),
    }),
    quoteExcelPreview: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: "api/orders/quote_excel_preview/",
          method: "POST",
          body: formData,
        };
      },
    }),
    duplicateRFQQuote: builder.mutation({
      query: (duplicateData) => ({
        url: "api/orders/rfq/duplicate_quote/",
        method: "POST",
        body: duplicateData,
      }),
    }),
    deleteRFQQuote: builder.mutation({
      query: (deleteId) => ({
        url: `api/orders/rfq/delete_quote/`,
        method: "DELETE",
        body: deleteId,
      }),
    }),
    addNewImage: builder.mutation({
      query: (imageFile) => {
        const formData = new FormData();
        formData.append("image", imageFile);
        return {
          url: "api/utility/image_upload/",
          method: "POST",
          body: formData,
        };
      },
    }),
    addNewAddress: builder.mutation({
      query: (addNewAddress) => ({
        url: "accounts/mob_user/create_address/",
        method: "POST",
        body: addNewAddress,
      }),
    }),
    updateAddress: builder.mutation({
      query: (updateAddress) => ({
        url: "accounts/mob_user/update_address/",
        method: "PATCH",
        body: updateAddress,
      }),
    }),
    deleteAddress: builder.mutation({
      query: (addressId) => ({
        url: `accounts/mob_user/delete_address/`,
        method: "DELETE",
        body: addressId,
      }),
    }),
    deleteQuoteItem: builder.mutation({
      query: (params) => ({
        url: "api/orders/rfq/delete_quote_item/",
        method: "DELETE",
        body: params,
      }),
    }),
    deleteQuoteTable: builder.mutation({
      query: (params) => ({
        url: "api/orders/rfq/delete_quote_vendor/",
        method: "DELETE",
        body: params,
      }),
    }),

    getReportingManagers: builder.query({
      query: (id) => ({
        url: `/api/accounts/dashboard/get_reporting_managers/`,
      }),
    }),
  }),
});

export const {
  useGetRFQUserByIdQuery,
  useLazyGetRFQUserByIdQuery,
  // useLazyGetAllVendorsQuery,
  useLazyGetRFQQuoteDetailQuery,
  useGetAllVendorsQuery,
  useLazyGetAllVendorsQuery,
  useLazyGetCatalogueByVendorQuery,
  useCreateRFQQuoteMutation,
  useUpdateRFQQuoteDetailsMutation,
  useAddNewAddressMutation,
  useDeleteAddressMutation,
  useUpdateAddressMutation,
  useAddNewImageMutation,
  useUpdateRFQQuoteMutation,
  useQuoteExcelPreviewMutation,
  useDuplicateRFQQuoteMutation,
  useDeleteRFQQuoteMutation,
  useDeleteQuoteItemMutation,
  useDeleteQuoteTableMutation,
  useLazyGetCatalogueByVendorModalQuery,
  useLazyGetCatalogueByVendorDrawerQuery,
  useLazyGetReportingManagersQuery
} = createQuoteAPI;

export default createQuoteAPI;
